import { render, staticRenderFns } from "./dashboard-rank.vue?vue&type=template&id=929d5c94&scoped=true&"
import script from "./dashboard-rank.vue?vue&type=script&lang=js&"
export * from "./dashboard-rank.vue?vue&type=script&lang=js&"
import style0 from "./dashboard-rank.vue?vue&type=style&index=0&id=929d5c94&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "929d5c94",
  null
  
)

export default component.exports